module.exports = __webpack_public_path__ + "img/sala-xpto2.70443e41.jpg";